import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdChat, MdCheckCircleOutline, MdNotificationsNone } from 'react-icons/md';

const InAppCallScreen = ({ onNavigate, onBack }) => {
  const [callActive, setCallActive] = useState(false);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    let interval = null;
    if (callActive) {
      interval = setInterval(() => {
        setSeconds(prev => prev + 1);
      }, 1000);
    } else {
      setSeconds(0);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [callActive]);

  const formatTime = (s) => {
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="screen call-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Call Us</h1>
        </div>
      </header>

      <div className="scroll-content white-bg call-content">
        <div className="call-hero">
          <div className="call-avatar-container">
            <div className={`call-ripple ${callActive ? 'animate' : ''}`}></div>
            <div className="call-avatar">
              <MdChat size={40} color="white" />
            </div>
          </div>

          <h2 className="call-status">
            {callActive ? 'Connected' : 'Ready to Connect'}
          </h2>
          <p className="call-timer">{callActive ? formatTime(seconds) : 'Secure In-App Call'}</p>
        </div>

        {!callActive ? (
          <div className="call-pre-check">
            <div className="check-item">
              <MdCheckCircleOutline className="positive-green" />
              <span>Identity Verified</span>
            </div>
            <div className="check-item">
              <MdCheckCircleOutline className="positive-green" />
              <span>Encrypted Connection</span>
            </div>
            <button className="call-primary-btn" onClick={() => setCallActive(true)}>
              START CALL
            </button>
            <p className="call-disclaimer">Standard data rates may apply. Average wait time: <span className="positive-green">&lt; 2 mins</span></p>
          </div>
        ) : (
          <div className="call-controls">
            <div className="control-row">
              <div className="control-btn"><MdNotificationsNone /><span>Mute</span></div>
              <div className="control-btn"><MdNotificationsNone /><span>Speaker</span></div>
              <div className="control-btn"><MdNotificationsNone /><span>Keypad</span></div>
            </div>
            <button className="end-call-btn" onClick={() => setCallActive(false)}>
              END CALL
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InAppCallScreen;
